export { habiOrganizationAllowed } from '../../../../supabase/functions/_shared/habiPilotScope';
export function pilotEnvironmentAllowed(enabled:boolean,backend:string,core:string,hostname:string):boolean {
  return enabled && backend === 'https://dev-sb.flusia.it' && core === 'https://dev-core.flusia.it' && ['dev.flusia.it','localhost','127.0.0.1'].includes(hostname);
}
export function pilotStorageKey(userId:string,organizationId:string):string {
  return `flusia:habi:enabled:${organizationId}:${userId}`;
}
